module.exports = __webpack_public_path__ + "img/office_3.4a279ba6.jpeg";